/**
 * Генерирует строку-выражение для передачи в env-параметр SLD-стиля,
 * позволяющее скрыть указанные подтипы дорожных объектов.
 *
 * Формат результата: "hideWayside;hideRoadLandLot;…" — для каждого имени из входного
 * списка берётся первая заглавная буква и добавляется префикс «hide».
 *
 * @param objectTypes  Один тип (строка) или массив типов (string[])
 *                     Например: "wayside" либо ["wayside", "roadLandLot"].
 *                     Допустимы пустая строка, null или [], —
 *                     в этом случае ничего скрывать не нужно.
 *
 * @returns Строка вида "hideTypeA;hideTypeB" либо undefined, если список пуст.
 */
export function configureAllObjectsLayerHideExpression(
    objectTypes?: string | string[] | null
): string | undefined {
    const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

    // приводим к массиву и фильтруем пустые строки
    const types = (Array.isArray(objectTypes) ? objectTypes : objectTypes ? [objectTypes] : [])
        .filter(Boolean);

    return types.length ? types.map(t => `hide${capitalize(t)}`).join(';') : undefined;
}